import { call, put, select, takeEvery } from 'redux-saga/effects';

import { getLogger } from '../../utils/core';
import { featureFlagsSelectors } from '../feature-flags';
import { memorizedRulesActions, memorizedRulesSelectors } from '../memorized-rules';
import { transactionsActions, transactionsSelectors, transactionsTypes } from '../transactions';

import * as preProcess from './preProcess';

const log = getLogger('features/transactions/transactionsFeatureSagas.js');

export function* createMemorizedRuleSuccessActionWatcher() {
  yield takeEvery(memorizedRulesActions.createMemorizedRuleSuccess, function* createMemorizedRuleSuccess(action) {
    if (action.meta?.props?.applyToTransactions && Math.trunc(action.meta?.response?.status / 100) === 2) {
      yield call(applyMemorizedRule, action);
    }
  });
}

export function* updateMemorizedRuleSuccessActionWatcher() {
  yield takeEvery(memorizedRulesActions.updateMemorizedRuleSuccess, function* updateMemorizedRuleSuccess(action) {
    if (action.meta?.props?.applyToTransactions && Math.trunc(action.meta?.response?.status / 100) === 2) {
      yield call(applyMemorizedRule, action);
    }
  });
}

function* applyMemorizedRule(action) {
  const memorizedRuleOld = action.meta.props?.memorizedRule;
  const memorizedRuleApplicableTransactions = yield select(
    memorizedRulesSelectors.getMemorizedRuleApplicableTransactions,
    action.payload,
    memorizedRuleOld,
  );
  if (memorizedRuleApplicableTransactions.size) {
    const txnsToUpdate = memorizedRuleApplicableTransactions
      .toIndexedSeq()
      .toArray()
      .map((transaction) =>
        transactionsTypes.mkCashFlowTransaction({
          ...transaction?.toJS?.(),
          coa: action.payload.coa,
        }),
      );
    const txnsByAccountId = yield select(transactionsSelectors.getTransactionsByAccountId);
    const featureFlags = yield select(featureFlagsSelectors.getFeatureFlags);
    const { errors, ...txnPack } = preProcess.preProcessUpdate({
      txns: txnsToUpdate,
      txnsByAccountId,
      featureFlags,
    });
    if (errors?.length > 0) {
      log.error(
        'There was a problem applying memorized rules' +
          '\nThe problem likely happened in preprocess from applying changes to past txns',
      );
    }
    preProcess.addMatches(txnPack);
    const { allTxnsToDelete, allTxnsToUpdate, allTxnsToCreate } = txnPack;
    const transactions = [...allTxnsToDelete, ...allTxnsToUpdate, ...allTxnsToCreate];
    if (transactions.length > 0) {
      yield put(
        transactionsActions.batchTransactions(transactions, {
          context: 'memorized-rules',
          undo: { userMessage: 'Transaction(s) updated.' },
        }),
      );
    }
  }
}

export function* combineMemorizedRulesSuccessActionWatcher() {
  yield takeEvery(
    memorizedRulesActions.combineMemorizedRulesSuccess,
    function* applyMemorizedRuleToTransactions(action) {
      if (
        action.meta?.props?.applyToTransactions &&
        Math.trunc(action.meta?.response?.status / 100) === 2 &&
        action.payload?.length === 2
      ) {
        // we need to fake the action for applyMemorizedRule to make sure it uses the correct rules
        const actionForApply = { ...action, payload: action.payload[1] }; // meta should have an empty object as the old rule
        yield call(applyMemorizedRule, actionForApply);
      }
    },
  );
}

export default [
  createMemorizedRuleSuccessActionWatcher,
  updateMemorizedRuleSuccessActionWatcher,
  combineMemorizedRulesSuccessActionWatcher,
];
